import { HelpCall } from 'src/assets'
import { HelpEmail } from 'src/assets'
import { HelpTweet } from 'src/assets'
import { HelpChat } from 'src/assets'

interface IHelpData {
  id: number
  title: string
  img?: any
  linkAdd?: string
}

export const helpData: IHelpData[] = [
  {
    id: 1,
    title: 'Email Us',
    img: HelpEmail,
    linkAdd: 'mailto:support@fandksavings.com',
  },
  {
    id: 2,
    title: 'Chat Us',
    img: HelpChat,
    linkAdd: 'https://wa.me/2348108773812',
  },
  {
    id: 3,
    title: 'Call Us',
    img: HelpCall,
    linkAdd: 'tel:+2348108773812',
  },
  {
    id: 4,
    title: 'Dm Us',
    img: HelpTweet,
    linkAdd: 'https://twitter.com/fandksavings',
  },
]
